import { dto_CustomerAddress } from "../../../../classes/dto-customer";
import { GET_SET_STORED_DATA } from "../../../../database/get-stored-data";
import { SET_STORE_PAGE_URL } from "../../../../database/store-data";
import { PT_ADDRESSLIST } from "../../../../routes/stack/paths/pt-profile";
import { PT_CART } from "../../../../routes/stack/paths/pt-cart";
import React from "react";
import "../../../../styles/css/pg-cart.css";

export default class Address extends React.Component {
  async componentDidMount() {
    await GET_SET_STORED_DATA();
  }
  render() {
    return (
      <div
        className="pgCartAdd"
        style={{ cursor: "pointer", paddingLeft: "-5px" }}
        onClick={async () => {
          await SET_STORE_PAGE_URL(PT_CART);
          this.props.navigate(PT_ADDRESSLIST.replace(":frompage", "cart"));
        }}
      >
        <div className="pgCartAddWrap">
          <i
            className="bi bi-geo-alt-fill"
            aria-hidden="true"
            style={{ fontSize: "24px" }}
          />
          <p style={{ textAlign: "left" }}>
            {dto_CustomerAddress.DefaultAdd1 +
              " " +
              dto_CustomerAddress.DefaultAdd2 +
              " " +
              dto_CustomerAddress.DefaultAdd3}
          </p>
        </div>

        <div
          className="pgCartAddEdit"
          onClick={async () => {
            await SET_STORE_PAGE_URL(PT_CART);
            this.props.navigate(PT_ADDRESSLIST.replace(":frompage", "cart"));
          }}
        >
          <i
            class="bi bi-caret-right-fill"
            aria-hidden="true"
            style={{ fontSize: "18px", marginTop: "5px" }}
          />
        </div>
      </div>
    );
  }
}
